import Banner from '../components/Banner';
import ColumnGrid from '../components/ColumnGrid';
import Image from '../components/Image';
import TextGrid from '../components/TextGrid';
import TextOnly from '../components/TextOnly';
import Carousel from '../components/Carousel';
import CarouselChild from '../components/CarouselChild';
import SlidingWidget from '../components/SlidingWidget';
import InFocus from '../components/InFocus';
import SlidingWidgetV2 from '../components/SlidingWidgetV2';
import widgetTypes from '../constants/widgetTypes';
import BannerV2 from '../components/BannerV2';
import ColumnGridV2 from '../components/ColumnGridV2';
import CarouselV2 from '../components/CarouselV2';
import SectionWrapper from '../components/SectionWrapper';
import Recommendation from '../components/Recommendation';
import Story from '../components/Story';
import ProductV2 from '../components/ProductV2';
import ProductWidget from '../components/ProductWidget';
import ProductV2Child from '../components/ProductV2Child';
import Video from '../components/Video';
import ListView from '../components/ListView';
import ListViewChild from '../components/ListViewChild';
const WidgetMap = {
    [widgetTypes.BANNER]: Banner,
    [widgetTypes.CAROUSEL]: Carousel,
    [widgetTypes.CAROUSEL_CHILD]: CarouselChild,
    [widgetTypes.COLUMN_GRID]: ColumnGrid,
    [widgetTypes.IMAGE]: Image,
    [widgetTypes.IN_FOCUS]: InFocus,
    [widgetTypes.SLIDING_WIDGET]: SlidingWidget,
    [widgetTypes.TEXT_GRID]: TextGrid,
    [widgetTypes.TEXT_ONLY]: TextOnly,
    [widgetTypes.STORY]: Story,
    [widgetTypes.SLIDING_WIDGET_V2]: SlidingWidgetV2,
    [widgetTypes.BANNER_V2]: BannerV2,
    [widgetTypes.COLUMN_GRID_V2]: ColumnGridV2,
    [widgetTypes.CAROUSEL_V2]: CarouselV2,
    [widgetTypes.SECTION]: SectionWrapper,
    [widgetTypes.RECOMMENDATION_WIDGET]: Recommendation,
    [widgetTypes.PRODUCT_WIDGET]: ProductWidget,
    [widgetTypes.PRODUCT_WIDGET_V2_CHILD]: ProductV2Child,
    [widgetTypes.PRODUCT_WIDGET_V2]: ProductV2,
    [widgetTypes.VIDEO]: Video,
    [widgetTypes.LIST_VIEW_WIDGET]: ListView,
    [widgetTypes.LIST_VIEW_CHILD]: ListViewChild,
};
export default WidgetMap;
